import { IGetRegionMetaResponse } from '../repositories/geo-temp-layer/entities/region_meta/GetRegionMetaResponse';
import { TRegionMeta } from '../types/regionMeta';

export function prepareRegionMeta(response: IGetRegionMetaResponse): TRegionMeta {
  const { location } = response;

  if (!location) {
    return null;
  }

  return {
    id: location.id as number,
    displayName: location.displayName || '',
    baseHost: location.baseHost,
    mainTownId: location.mainTownId ?? undefined,
    parentId: location.parentId ?? undefined,
  };
}
